export default __webpack_public_path__ + "static/media/Stage4_rule.71543c87.png";